export function initCommentSystem() {
  // 1. Initialize states: Remove any style display properties
  document.querySelectorAll('.comment-inner .comment-form-wrapper').forEach(el => {
    el.removeAttribute('style');
  });

  // 2. Click Handler for General Comment Placeholders
  document.querySelectorAll('.blog-comment-section .comment-placeholder').forEach(placeholder => {
    placeholder.addEventListener('click', function (e) {
      e.preventDefault();
      const commentInner = this.closest('.comment-inner');
      if (commentInner) {
        commentInner.classList.add('comment-box-open');
      }
    });
  });

  // 3. Click Handler for General Cancel Buttons
  document.querySelectorAll('.cancel-btn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const commentInner = this.closest('.comment-inner');
      if (commentInner) {
        commentInner.classList.remove('comment-box-open');
        const replyPart = this.closest('.reply-part');
        if (replyPart) {
          replyPart.classList.remove('comment-box-open');
        }
      }
    });
  });

  // 4. Click Handler for Reply-To-Comment trigger
  document.querySelectorAll('.reply-part .reply-to-comment').forEach(replyBtn => {
    replyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const replyPart = this.closest('.reply-part');
      if (replyPart) {
        replyPart.classList.add('comment-box-open');
      }
    });
  });

  // 5. WordPress Core #cancel-comment-reply-link click handler
  const cancelCommentReplyLink = document.getElementById('cancel-comment-reply-link');
  if (cancelCommentReplyLink) {
    cancelCommentReplyLink.addEventListener('click', function (e) {
      e.preventDefault();
      const commentInner = this.closest('.comment-inner');
      if (commentInner) {
        commentInner.classList.remove('comment-box-open');
        const replyPart = this.closest('.reply-part');
        if (replyPart) {
          replyPart.classList.remove('comment-box-open');
        }
      }
    });
  }

  // 6. Event delegation for dynamically added links: Click on ".comment-reply-link"
  document.addEventListener('click', function (e) {
    const replyLink = e.target.closest('.comment-reply-link');
    if (replyLink) {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('.comment .reply-part').forEach(el => {
        el.classList.remove('hide-reply-text');
      });
      
      const replyPart = replyLink.closest('.reply-part');
      if (replyPart) {
        replyPart.classList.add('hide-reply-text');
      }

      const comment = replyLink.closest('.comment');
      if (comment) {
        const respond = document.getElementById('respond');
        if (respond) {
          // If respond is not wrapped in .respond-wrapper, wrap it
          if (!respond.parentElement.classList.contains('respond-wrapper')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'respond-wrapper';
            respond.parentNode.insertBefore(wrapper, respond);
            wrapper.appendChild(respond);
          }

          const respondWrapper = respond.parentElement;
          
          // Move the respondWrapper directly under the comment body if it isn't already there
          const commentBody = comment.querySelector('.comment-body');
          if (commentBody && respondWrapper.parentElement !== commentBody) {
            commentBody.appendChild(respondWrapper);
          }

          // Show the wrapper by adding class
          setTimeout(() => {
            respondWrapper.classList.add('is-open');
          }, 10);
          
          // Unhide WordPress cancel button
          const cancelBtn = document.getElementById('cancel-comment-reply-link');
          if (cancelBtn) {
            cancelBtn.style.display = 'inline-block';
          }
          
          // Manually update comment_parent value
          const commentParentInput = document.getElementById('comment_parent');
          const commentId = replyLink.getAttribute('data-commentid');
          if (commentParentInput && commentId) {
            commentParentInput.value = commentId;
          }
        }
      }
    }
  });

  // 7. Event delegation for Cancel buttons
  document.addEventListener('click', function (e) {
    const cancelBtn = e.target.closest('.btn.cancel-btn') || e.target.closest('#cancel-comment-reply-link');
    if (cancelBtn) {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('.comment .reply-part').forEach(el => {
        el.classList.remove('hide-reply-text');
      });
      
      const respondWrapper = cancelBtn.closest('.respond-wrapper');
      if (respondWrapper) {
        respondWrapper.classList.remove('is-open');
      }

      // Also close main comment box if it was open
      const commentPart = document.querySelector('.write-comment-wrapper .write-comment-part');
      if (commentPart) {
        commentPart.classList.remove('comment-box-open');
      }

      // Reset parent comment ID to 0
      const commentParentInput = document.getElementById('comment_parent');
      if (commentParentInput) {
        commentParentInput.value = '0';
      }
      
      cancelBtn.style.display = 'none';
    }
  });

  // 8. General reply link trigger handling
  document.querySelectorAll('.comment-reply-link').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.write-comment-wrapper .write-comment-part').forEach(el => {
        el.classList.remove('comment-box-open');
      });
      const cancelBtn = document.getElementById('cancel-comment-reply-link');
      if (cancelBtn) {
        cancelBtn.click();
      }
    });
  });

  // 9. Main comment placeholder click handling
  document.querySelectorAll('.write-comment-text .comment-placeholder').forEach(placeholder => {
    placeholder.addEventListener('click', function (e) {
      e.preventDefault();

      const respond = document.getElementById('respond');
      const mainFormWrapper = document.querySelector('.write-comment-part .comment-form-wrapper');
      
      if (respond && mainFormWrapper) {
        // Move the respond block back to the main top container
        if (respond.parentElement !== mainFormWrapper) {
          mainFormWrapper.appendChild(respond);
        }
        
        // Hide list wrappers
        document.querySelectorAll('.comment-list .respond-wrapper').forEach(wrapper => {
          wrapper.classList.remove('is-open');
        });

        const commentParentInput = document.getElementById('comment_parent');
        if (commentParentInput) {
          commentParentInput.value = '0';
        }
      }

      const commentPart = document.querySelector('.write-comment-wrapper .write-comment-part');
      if (commentPart) {
        commentPart.classList.add('comment-box-open');
      }
    });
  });
}


/* Helper: Slide Up Transition Engine */
function slideUp(element, duration = 350) {
  element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
  element.style.boxSizing = 'border-box';
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight; // force repaint
  element.style.overflow = 'hidden';
  element.style.height = '0';
  element.style.paddingTop = '0';
  element.style.paddingBottom = '0';
  element.style.marginTop = '0';
  element.style.marginBottom = '0';
  
  window.setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
    element.style.removeProperty('box-sizing');
  }, duration);
}

/* Helper: Slide Down Transition Engine */
function slideDown(element, duration = 350) {
  // Reset display property to get actual height
  element.style.display = 'block';
  element.style.height = 'auto';
  let height = element.offsetHeight;
  
  // Set starting state for animation
  element.style.overflow = 'hidden';
  element.style.height = '0';
  element.style.paddingTop = '0';
  element.style.paddingBottom = '0';
  element.style.marginTop = '0';
  element.style.marginBottom = '0';
  element.offsetHeight; // force repaint
  
  // Start transition
  element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
  element.style.boxSizing = 'border-box';
  element.style.height = height + 'px';
  
  element.style.removeProperty('padding-top');
  element.style.removeProperty('padding-bottom');
  element.style.removeProperty('margin-top');
  element.style.removeProperty('margin-bottom');
  
  window.setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition');
    element.style.removeProperty('box-sizing');
  }, duration);
}
